/*
 * @Author: etong
 * @Date: 2021-01-27 13:51:41
 * @LastEditTime: 2021-07-30 16:39:12
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\store\getters\activitySetpriceManagement\activityDetail.js
 * @Think first, Program later
 */
const activityDetailGetters = {
  activityFormdata: state => state.activityDetail.activityFormdata,
  mainProduct: state => state.activityDetail.mainProduct,
  msMainProduct: state => state.activityDetail.msMainProduct, // 满送主商品
  productTabObj: state => state.activityDetail.productTabObj,
  msMainGroupProduct: state => state.activityDetail.msMainGroupProduct, // 满送主商品套装
  msMainGroupProductSku: state => state.activityDetail.msMainGroupProductSku, // 满送主商品套装明细
  filterObj: state => state.activityDetail.filterObj,
  msGiftProduct: state => state.activityDetail.msGiftProduct, // 满送赠品
  msGiftGroupProduct: state => state.activityDetail.msGiftGroupProduct, // 满送赠品套装
  msGiftGroupProductSku: state => state.activityDetail.msGiftGroupProductSku, // 满送赠品套装明细
  productTabSelected: state => state.activityDetail.productTabSelected, // 满送标签选择项
  chooseListProduct: state => state.activityDetail.chooseListProduct, // 选择的列表行数据
  jjflowData: state => state.activityDetail.jjflowData // 审批流数据
}

export default activityDetailGetters
